import React from "react";
import "./BlogView.css";
import hero from "../../assets/img/blogs/demo_blog.png"
import { useSelector } from "react-redux";

const BlogView = () => {
    const { singleBlogData } = useSelector(state => state.service);

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString("en-GB", { month: "long" });
        const year = date.getFullYear();

        return `${month} ${day}, ${year}`;
    }

    // usage of formatDate

    // const result = formatDate("2026-01-02");

    // Output: 2 January, 2026


    return (<>
        <div className="blog-wrapper">

            <div className="main-content">
                <img src={singleBlogData?.featured_image || hero} alt="" />
            </div>
            <div className="d-flex blog-content">
                <div className="blog-content-left">
                    <p>{formatDate(singleBlogData?.date || "")} | {singleBlogData?.category || ""}</p>
                    <h3>{singleBlogData?.title || ""}</h3>
                    <p>by {singleBlogData?.author?.name || ""}</p>
                </div>
                <div className="blog-content-right" dangerouslySetInnerHTML={{ __html: singleBlogData?.content }}>
                </div>
            </div>


            {/* Right Vertical Label */}


        </div>
        <aside className="vertical-label side-vertical-heading top-p-40 right-28 top-110">
            <span>{singleBlogData?.title}</span> <span className="small-spacer"></span> <span>THE PRIVATE STANDARD (A BLOG)</span> <span className="small-spacer"></span><span>{formatDate(singleBlogData?.date)}</span>
        </aside> </>
    );
};

export default BlogView;
